import * as FiIcons from 'react-icons/fi';

export const NORDIC_DIMENSIONS = [
  { id: 'workload', label: 'Workload & Demands', icon: 'FiClock', color: 'rose', description: 'Arbeidsmengde, tidspress og ressursfordeling.' },
  { id: 'role_clarity', label: 'Role Clarity', icon: 'FiTarget', color: 'indigo', description: 'Forventningsavklaring og ansvarsområder.' },
  { id: 'autonomy', label: 'Autonomy & Control', icon: 'FiZap', color: 'amber', description: 'Innflytelse på egen arbeidshverdag og beslutninger.' },
  { id: 'leadership', label: 'Leadership Support', icon: 'FiUserCheck', color: 'emerald', description: 'Nærmeste leders evne til støtte og veiledning.' },
  { id: 'collaboration', label: 'Team Collaboration', icon: 'FiUsers', color: 'blue', description: 'Samspill, informasjonsdeling og støtte i teamet.' },
  { id: 'psych_safety', label: 'Psychological Safety', icon: 'FiShield', color: 'violet', description: 'Trygghet til å feile og si sin mening.' },
  { id: 'conflict', label: 'Conflict & Relations', icon: 'FiMessageSquare', color: 'orange', description: 'Håndtering av uenigheter og sosiale relasjoner.' },
  { id: 'communication', label: 'Communication', icon: 'FiGlobe', color: 'cyan', description: 'Informasjonsflyt og åpenhet i organisasjonen.' },
  { id: 'culture', label: 'Org. Culture', icon: 'FiActivity', color: 'pink', description: 'Felles verdier, normer og uformelle regler.' },
  { id: 'change', label: 'Change Management', icon: 'FiRefreshCw', color: 'teal', description: 'Håndtering av omstilling og endringsprosesser.' },
  { id: 'learning', label: 'Learning & Dev', icon: 'FiBookOpen', color: 'sky', description: 'Mulighet for kompetanseheving og personlig vekst.' },
  { id: 'stress', label: 'Stress & Recovery', icon: 'FiCoffee', color: 'red', description: 'Evne til restitusjon og forebygging av stress.' }
];

export const LIKERT_SCALE = [
  { value: 1, label: 'Strongly disagree' },
  { value: 2, label: 'Disagree' },
  { value: 3, label: 'Neutral' },
  { value: 4, label: 'Agree' },
  { value: 5, label: 'Strongly agree' }
];

// Genererer eksempler for å demonstrere kapasitet (i en ekte app hentes disse fra DB)
export const getQuestionsForDimension = (dimId) => {
  const baseQuestions = {
    workload: [
      'Jeg har nok tid til å fullføre mine arbeidsoppgaver.',
      'Arbeidsmengden min er jevnt fordelt over tid.',
      'Jeg opplever sjelden uventet tidspress som påvirker kvaliteten.'
    ],
    psych_safety: [
      'Det er lett å be om hjelp i mitt team.',
      'Ingen blir straffet for å gjøre feil i dette teamet.',
      'Vi diskuterer åpent vanskelige temaer og utfordringer.'
    ]
  };
  
  const questions = baseQuestions[dimId] || ['Standard spørsmål for ' + dimId];
  return questions.map((q, i) => ({
    id: `${dimId}-${i}`,
    text: q,
    dimension: dimId,
    isStandard: true
  }));
};